import { render } from "./InputSelect.vue?vue&type=template&id=ebb057d2&scoped=true&ts=true"
import script from "./InputSelect.vue?vue&type=script&lang=ts"
export * from "./InputSelect.vue?vue&type=script&lang=ts"

import "./InputSelect.vue?vue&type=style&index=0&id=ebb057d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb057d2"]])

export default __exports__